export default "__VITE_ASSET__PJxNxnwt__"